/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Customssoacrvalue3Inputs */

const en_entity_customssoacrvalue3 = /** @type {(inputs: Entity_Customssoacrvalue3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom SSO ACR Value`)
};

const de_entity_customssoacrvalue3 = /** @type {(inputs: Entity_Customssoacrvalue3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom SSO ACR Wert`)
};

/**
* | output |
* | --- |
* | "Custom SSO ACR Value" |
*
* @param {Entity_Customssoacrvalue3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_customssoacrvalue3 = /** @type {((inputs?: Entity_Customssoacrvalue3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Customssoacrvalue3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_customssoacrvalue3(inputs)
	return de_entity_customssoacrvalue3(inputs)
});
export { entity_customssoacrvalue3 as "entity_customSsoAcrValue" }